// Themes
import './assets/scss/Saas.scss';

import * as Sentry from '@sentry/react';

// @flow
import React, { Component } from 'react';

import AppRoutes from './routes/AppRoutes';
import { createFeatureFlagProvider } from '#helpers/featureFlags';
import ErrorFallback from '#components/ErrorFallback.js';
import { captureAndStoreUrlParams } from '#helpers/urlParamsUtils.js';

let userData = {};
try {
  userData = JSON.parse(localStorage.getItem("user") || "{}");
} catch (e) {
  userData = {};
}

if (userData?.email) {
  Sentry.setUser({ email: userData.email });
}
/**
 * Main app component
 */
class App extends Component {
    componentDidMount() {
        // Capture URL parameters for prefilling forms
        captureAndStoreUrlParams();
    }

    render() {
        return (
            <Sentry.ErrorBoundary fallback={ErrorFallback}>
                <AppRoutes></AppRoutes>
            </Sentry.ErrorBoundary>
        );
    }
}

export default createFeatureFlagProvider(App);
